import { FieldConfig } from "~/components/Forms/DealerPassportForm2/types";

export const EDITABLE_BASE_FIELDS = [
  "dealerType",
  "holdingName",
  "beginWorkingDate",
];

export const getDealerFields = (t: (key: string) => string): FieldConfig[] => [
  {
    name: "dealerType",
    label: "Признак",
    type: "select",
    options: DEALER_TYPE_LIST,
  },
  {
    name: "id",
    label: t(`dealers.id`),
    type: "text",
    disabled: true,
  },
  {
    name: "dealerName",
    label: t(`dealers.DealerName`),
    type: "text",
    required: true,
  },
  {
    name: "legalDealerName",
    label: t(`dealers.legalDealerName`),
    type: "text",
  },
  {
    name: "tradeDealerName",
    label: t(`dealers.tradeDealerName`),
    type: "text",
  },
  {
    name: "holdingName",
    label: "Наименование холдинга",
    type: "text",
  },
  {
    name: "organizationalLegalForm",
    label: t(`dealers.OrganizationalLegalForm`),
    type: "text",
  },
  {
    name: "category",
    label: t(`dealers.category`),
    type: "text",
  },
  {
    name: "newDealer",
    label: t(`dealers.newDealer`),
    type: "checkbox",
  },
  {
    name: "main",
    label: t(`dealers.Main`),
    type: "checkbox",
  },
  {
    name: "headCompanyId",
    label: t(`dealers.headCompanyId`),
    type: "select",
    options: [],
  },
  {
    name: "status",
    label: t(`dealers.status`),
    type: "select",
    options: DEALER_PASSPORT_OPTION_STATUS,
  },
  {
    name: "inn",
    label: t(`dealers.inn`),
    type: "text",
  },
  {
    name: "code",
    label: t(`dealers.code`),
    type: "text",
  },
  {
    name: "successorId",
    label: t(`dealers.successorId`),
    type: "select",
    options: [],
  },
  {
    name: "entfCode",
    label: t(`dealers.entfCode`),
    type: "text",
    disabled: true,
  },
  {
    name: "entfSuccessorNo",
    label: t(`dealers.entfSuccessorNo`),
    type: "text",
    disabled: true,
  },
  {
    name: "entfSuccessorCode",
    label: t(`dealers.entfSuccessorCode`),
    type: "text",
    disabled: true,
  },
  {
    name: "successorCode",
    label: t(`dealers.successorCode`),
    type: "text",
    disabled: true,
  },
  {
    name: `num_sogl`,
    label: t(`dealers.contract`),
    type: "text",
  },
  {
    name: `contractEndDate`,
    label: t(`dealers.contractEndDateDirector`),
    type: "text",
  },
  {
    name: `beginWorkingDate`,
    label: t(`dealers.contractStartDate`),
    type: "text",
  },
];

export const getDealerDopFields = (
  t: (key: string) => string
): FieldConfig[] => [
  {
    name: "corporateEmail",
    label: t(`dealers.corporateEmail`),
    type: "text",
  },
  {
    name: "hideOnLadaRu",
    label: t(`dealers.hideOnLadaRu`),
    type: "checkbox",
  },
  {
    name: "terminated",
    label: t(`dealers.terminated`),
    type: "checkbox",
  },
  {
    name: "extendedForNextYear",
    label: t(`dealers.extendedForNextYear`),
    type: "checkbox",
  },
  {
    name: "protocolOfConclusion",
    label: t(`dealers.protocolOfConclusion`),
    type: "text",
  },
  {
    name: "protocolOfTermination",
    label: t(`dealers.protocolOfTermination`),
    type: "text",
  },
  {
    name: "temporaryDecision",
    label: t(`dealers.temporaryDecision`),
    type: "checkbox",
  },
  {
    name: "DealerLADASERV",
    label: t(`dealers.DealerLADASERV`),
    type: "checkbox",
  },
  {
    name: "protocolOfIntentions",
    label: t(`dealers.protocolOfIntentions`),
    type: "checkbox",
  },
  {
    name: "updatedAt",
    label: t(`dealers.updatedAt`),
    type: "text",
    disabled: true,
  },
  {
    name: "ladaBusiness",
    label: t(`dealers.ladaBusiness`),
    type: "boolean",
  },
  {
    name: "ladaSport",
    label: t(`dealers.ladaSport`),
    type: "boolean",
  },
];

export const getDealerDopBir = (t: (key: string) => string): FieldConfig[] => [
  {
    name: "kgaCode",
    label: t(`dealers.KGA_CODE`),
    type: "text",
  },
  {
    name: "onecCode",
    label: t(`dealers.ONEC_CODE`),
    type: "text",
  },
  {
    name: "entId",
    label: t(`dealers.ent_id`),
    type: "text",
    disabled: true,
  },
  {
    name: "consumerCode",
    label: t(`dealers.consumerCode`),
    type: "text",
  },
  {
    name: "birCode",
    label: t(`dealers.birCode`),
    type: "text",
  },
];

export const DEALER_TYPE_LIST = [
  { value: "holding", label: "Холдинг" },
  { value: "filial", label: "Филиал" },
  { value: "auto", label: "Автономный" },
];

export const DEALER_PASSPORT_OPTION_STATUS = [
  { value: "active", label: "Активный" },
  { value: "inactive", label: "Неактивный" },
  { value: "candidate", label: "Кандидат" },
];
